import { useState, useEffect } from "react";
import axios from "axios";
import { Branch, ClockIns } from "../../../src/@types/mapTypes";

export function useBranchesLocalization(mockClockIns: ClockIns[]) {
  const [branch, setBranch] = useState<Branch[]>([]);

  useEffect(() => {
    (async function fetchData() {
      try {
        const { data } = await axios.get(
          `https://radar.tlpservicos.com.br/api/company/locations`
        );
        setBranch(data);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [mockClockIns]);

  return { branch };
}
